'use client';

import { Box } from '@mui/material';
import { useState } from 'react';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import { Virtual, Navigation, Pagination, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import InvestStepItem, { InvestStepItemProps } from './item/InvestStepItem';
export interface AnimateStepperProps {
  items: InvestStepItemProps[];
}
const AnimateStepper = ({
  items
}: AnimateStepperProps): JSX.Element => {
  const [swiperRef, setSwiperRef] = useState<SwiperClass | null>(null);
  const slideTo = (index: number) => {
    swiperRef && swiperRef.slideTo(index === items.length - 1 ? 0 : index + 1, 1000);
  };
  return <Box sx={{
    mx: 'auto',
    '& .swiper-initialized': {
      height: {
        xs: 158,
        md: 128
      }
    },
    '& .swiper-pagination-bullet': {
      height: 26,
      width: 4,
      borderRadius: 'var(--corner_radius_xl)'
    }
  }} data-sentry-element="Box" data-sentry-component="AnimateStepper" data-sentry-source-file="StepperSlider.tsx">
      <Swiper modules={[Mousewheel, Virtual, Navigation, Pagination]} onSwiper={setSwiperRef} virtual direction='vertical' slidesPerView={1} mousewheel={true} pagination={{
      clickable: true
    }} data-sentry-element="Swiper" data-sentry-source-file="StepperSlider.tsx">
        {items.map((item, idx) => <SwiperSlide onClick={() => {
        slideTo(idx);
      }} key={'step_' + idx} virtualIndex={idx}>
            <InvestStepItem {...item} />
          </SwiperSlide>)}
      </Swiper>
    </Box>;
};
export default AnimateStepper;